
import ImageCompressor from 'image-compressor.js'
import { mapActions } from 'vuex'
import axios from 'axios'

export default {
  data () {
    return {
      scene: 'USER_INFO_CHANGE',
      http: axios.create({
        headers: {
          'content-type': 'application/octet-stream;charset=utf-8'
        }
      })
    }
  },
  methods: {
    ...mapActions(['uploadSignUrl']),
    beforeRead (file, accept) {
      if (!['image/jpeg', 'image/png'].includes(file.type)) {
        this.$message('只允许上传jpg/png格式的图片！')
        return false
      }
      return true
    },
    onOversize (file) {
      console.log(file)
      this.$message('文件大小不能超过 10MB')
    },
    // 图片压缩
    compressor (file, quality = 0.8) {
      var _this = this
      return new Promise((resolve) => {
        return new ImageCompressor(file, {
          quality: quality,
          maxWidth: 1440,
          maxHeight: 1080,
          success (result) {
            if (result.size > 2 * 1000 * 1000) {
              _this.compressor(file, quality - 0.2)
            } else {
              resolve(result)
            }
          }
        })
      })
    },
    // 图片转化为base64
    getImgBase64 (file) {
      return new Promise((resolve) => {
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function (e) {
          let file = this.result.replace(/data:image\/\w*;base64,/, '')
          resolve(file)
        }
      })
    },
    // 上传图片
    async uploadImg (file, type) {
      let _file = []
      // let fileList = []
      if (!file?.length) {
        file.status = 'uploading'
        file.message = '上传中...'
        _file.push(file)
      } else {
        _file = file
      }
      const compress = _file.map(async (item) => {
        item.status = 'uploading'
        item.message = '上传中...'
        const img = await this.compressor(item.file)
        const fileInstance = new File([img], img.name, { type: img.type })
        return fileInstance
      })
      const files = await Promise.all(compress)
  
    
      const _lth = this[type].filter((item) => item.status === 'done').length
      files.forEach(async (item, index) => {
        const { success, data } = await this.uploadSignUrl({ scene: this.scene, fileName: item.name }) 
        if (success && data?.url) {
          const { status } = await this.http.put(data?.url, item) 
          if (status === 200) {
            this[type][index + _lth].reqUrl = data?.url 
            this[type][index + _lth].status = 'done'
          } else {
            this[type][index + _lth].status = 'failed'
            this[type][index + _lth].message = '上传失败'
            setTimeout(() => {
              this[type].splice(index + _lth, 1)  
            }, 500)
          }
   
          // fetch(data?.url, {
          //   method: 'PUT',
          //   headers: new Headers({
          //     'Content-Type': 'application/octet-stream;charset=utf-8'
          //   }),
          //   body: item
          // }).then((res) => {
          //   console.log(res.url)
          // })
        }
      })
    }
  }
}